module.exports = __webpack_public_path__ + "img/净网公约_横.3d33b4b0.png";